<template>
  <Modal :is-open="isOpen" @close="$emit('close')">
    <template #title>Add team member</template>
    <template #body>
      <div class="flex flex-col gap-4">
        <label class="flex flex-col gap-1 text-sm font-medium">
          Name
          <input
            v-model="name"
            type="text"
            placeholder="Team member name"
            class="border border-gray-brand-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-500"
          />
        </label>
        <label class="flex flex-col gap-1 text-sm font-medium">
          Phone number
          <input
            v-model="phone"
            type="tel"
            placeholder="(555) 555-5555"
            class="border border-gray-brand-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-500"
          />
        </label>
        <p v-if="error" class="text-sm text-red-600">{{ error }}</p>
        <p class="text-xs text-gray-brand-500">
          Team members log in with their own phone number and share your customers and orders.
        </p>
      </div>
    </template>
    <template #footer>
      <PrimaryButton size="lg" :isLoading="saving" :active="phoneIsValid" @click="submit">
        Add team member
      </PrimaryButton>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Molecules/Modal'
import PrimaryButton from '@/components/Molecules/PrimaryButton'
import merchantFetch from '@/utils/merchantFetch'

export default {
  name: 'AddTeamMemberModal',
  components: { Modal, PrimaryButton },
  props: {
    isOpen: { type: Boolean, default: false }
  },
  emits: ['close', 'added'],
  data() {
    return { name: '', phone: '', saving: false, error: null }
  },
  computed: {
    phoneIsValid() {
      return this.phone.replace(/\D/g, '').length >= 10
    }
  },
  watch: {
    isOpen(open) {
      if (open) {
        this.name = ''
        this.phone = ''
        this.error = null
      }
    }
  },
  methods: {
    async submit() {
      if (!this.phoneIsValid || this.saving) return
      this.saving = true
      this.error = null
      try {
        const res = await merchantFetch('reseller/members', {
          method: 'POST',
          body: JSON.stringify({ name: this.name, phone: this.phone.replace(/\D/g, '') })
        })
        this.$emit('added', res.data || [])
      } catch (e) {
        this.error =
          e.message === '422'
            ? 'This person is already a team member of another reseller. Ask the store owner to move them.'
            : 'Something went wrong. Please try again.'
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
